import React from 'react';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

export default function About() {
  return (
    <div className="app-shell">
      <Navbar showBack title="About Us" />
      <div className="page-body" style={{ paddingBottom: 80 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16, color: 'var(--navy)' }}>About NoBrand Store</h1>
        
        <p style={{ fontSize: 14, lineHeight: 1.8, color: '#444', marginBottom: 16 }}>
          NoBrand Store is a Chennai-based private label fashion brand offering quality garments, jewellery, watches, bags, and footwear — without the brand markup.
        </p>
        
        <p style={{ fontSize: 14, lineHeight: 1.8, color: '#444', marginBottom: 16 }}>
          We believe great style shouldn't come with a name tax. Every product we carry is carefully selected for quality, finish, and value — so you get the best without paying for a logo.
        </p>

        <p style={{ fontSize: 14, lineHeight: 1.8, color: '#444', marginBottom: 16 }}>
          We ship pan-India and update our catalogue regularly with new arrivals across all categories.
        </p>

        <div style={{ background: 'var(--white)', borderRadius: 10, padding: 16, border: '0.5px solid var(--card-border)', marginTop: 24 }}>
          <div style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--blue)', marginBottom: 12, fontWeight: 500 }}>Get in touch</div>
          <div style={{ fontSize: 13, color: '#444', marginBottom: 8 }}>📧 nobrandstore3@gmail.com</div>
          <div style={{ fontSize: 13, color: '#444' }}>📍 Chennai, Tamil Nadu, India</div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}